// --------------------------------------------------
//   Imports
// --------------------------------------------------

// React
import React, { useState, useEffect, useRef } from "react";

// Material UI
import {
    Box,
    Button,
    Grid2 as Grid,
    Link,
    Stack,
    Typography,
} from "@mui/material";



// --------------------------------------------------
//   Main Component
// --------------------------------------------------


function Header() {

  const isFullscreen = false;

  const title = "Heartsong Choir";

  // Compute the header and footer heights
  const headerHeight = {
    xs: "120px",
    sm: "65px",
    md: "65px",
  }

  return (
    <Box
      component="header"
      height={ headerHeight }
      width="100%"
      borderBottom="1px solid #D9D9D9"
      display={ isFullscreen ? "none" : "default" }
    >
      <Stack
        direction="row" justifyContent="space-between" alignItems="center"
        columnGap={2} rowGap={0}
        flexWrap={{xs: "wrap", md: "nowrap"}}
        height="100%"
        paddingX={4}
        position="relative"
        boxShadow="0px 2px 4px rgb(0 0 0 / 25%)"
      >

        <Box flexGrow={1} order={{xs: 1, sm: "unset"}}>
          <Typography variant="h1" fontSize="20pt" lineHeight={1}>
            { title }
          </Typography>
        </Box>

        <Box height={{xs: "fit-content", sm: "62%"}} width={{xs: "42%", sm: "fit-content"}} flexShrink={1} order={{xs: 0, sm: "unset"}} marginTop="8px">
          <img alt="Bienen logo" src='/images/Horizontal-NW-BIENEN.png' style={{objectFit: "contain", height: "100%", width: "auto"}} />
        </Box>

        <Box height={{xs: "fit-content", sm: "100%"}} width={{xs: "42%", sm: "fit-content"}} flexShrink={1} order={{xs: 0, sm: "unset"}}>
          <img alt="Lurie logo"  src='/images/Lurie Color Logo.png'     style={{objectFit: "contain", height: "100%", width: "auto"}} />
        </Box>

      </Stack>
    </Box>
  )
}



// --------------------------------------------------
//   Export(s)
// --------------------------------------------------

export default Header;
